var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import model from '../base.model';
import { isEmail, minLength, maxLength, isNumber } from '../../utils/validation.helper';
import { isEmpty } from '../../utils/helpers';

class pinModelForm extends model {

    static create() {
        return _extends({}, super.create(), {
            pin: '',
            pinError: '',
            email: '',
            emailError: '',
            isValid: true
        });
    }

    //region init

    //endregion

    //region form

    static validate(clientModel) {
        let { email, pin } = clientModel;
        let emailError = isEmpty(email) ? 'Empty' : isEmail(email);
        let pinError = isEmpty(pin) ? 'Empty' : minLength(4)(pin);
        pinError = pinError ? pinError : maxLength(4)(pin);
        pinError = pinError ? pinError : isNumber(pin);
        pinError = pinError && 'Pin ' + pinError.toLowerCase();
        emailError = emailError && 'Email: ' + emailError.toLowerCase();

        // no validation, this is for generate PIN
        pinError = '';

        let isValid = !pinError && !emailError;

        return {
            pin,
            pinError,
            email,
            emailError,
            isValid
        };
    }

    static getPlaceholders(form, error) {
        const {
            pin,
            pinError,
            isValid
        } = form;

        let pinPlaceholder = 'Here is will be generated PIN';
        let emailPlaceholder = 'Email';

        // validation by network error
        let emailError = '';
        if (error) {
            if (error.message) {
                emailError = error.message;
                // emailError = error.message.toLowerCase() === 'Network Error'.toLowerCase() ?
                //     error.message : 'Credentials are invalid';
            } else if (error.data && error.data.message) {
                emailError = error.data.message;
            }
        }

        return {
            emailError,
            pinPlaceholder,
            emailPlaceholder
        };
    }

    //endregion

    //region actions

    static actionOnClearForm(model, clientModel) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_CLEAR_FORM,
                payload: { model, clientModel }
            });
        };
    }

    static actionOnValidate(model, form) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_VALIDATE_FORM,
                payload: { model, form }
            });
        };
    }

    static actionOnChangeEmail(model, email) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_CHANGE_EMAIL,
                payload: { model, email }
            });
        };
    }

    static actionOnChangePin(model, pin) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_CHANGE_PIN,
                payload: { model, pin }
            });
        };
    }

    //endregion

    //region reducer

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE_ON_CLEAR_FORM]: model.reduceOnClearForm,
            [model.TYPE_ON_VALIDATE_FORM]: model.reduceOnValidateForm,
            [model.TYPE_ON_VALIDATE_FORM]: model.reduceOnValidateForm,
            [model.TYPE_ON_CHANGE_PIN]: model.reduceOnChangePin,
            [model.TYPE_ON_CHANGE_EMAIL]: model.reduceOnChangeEmail
        };

        return reducers[type];
    }

    static reduceOnClearForm(stateModel, action) {
        const { model, clientModel } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, model.create(), clientModel)
        };
    }

    static reduceOnValidateForm(stateModel, action) {
        const { model, form } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, form)
        };
    }

    static reduceOnChangeEmail(stateModel, action) {
        const { model, email } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isValid: true,
                email,
                emailError: ''
            })
        };
    }

    static reduceOnChangePin(stateModel, action) {
        const { model, pin } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                pin
            })
        };
    }
}

pinModelForm.MODEL_NAME = 'pinModelForm';
pinModelForm.TYPE_ON_CLEAR_FORM = 'TYPE_PIN__ON_CLEAR_FORM';
pinModelForm.TYPE_ON_VALIDATE_FORM = 'TYPE_PIN__ON_VALIDATE_FORM';
pinModelForm.TYPE_ON_CHANGE_PIN = 'TYPE_PIN__ON_CHANGE_PIN';
pinModelForm.TYPE_ON_CHANGE_EMAIL = 'TYPE_RESTORE_PASS__ON_CHANGE_EMAIL';
export { pinModelForm };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/auth/pin.model.form.js